let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6Z8WE")).then(() => parcelRequire('iaMDd'));